import {post} from '../axios'

const api = {
    // 可充值会员卡列表
    memberCardList() {
      return post("member/card/memberCardList");
    },
    // 可充值套餐列表
    packageList() {
      return post("member/card/packageList");
    },
    // 获取套餐内项目
    getPackageItemList({id}  ) {
      return post("member/card/getPackageItemList", {id});
    },
    // 会员卡充值设定列表
    getRechargeList() {
      return post("member/card/getRechargeList");
    },
    // 会员卡更换卡下单
    placeCardOrder({id}) {
      return post("member/card/placeCardOrder", {id});
    },
    // 会员卡充值下单
    placeRechargeOrder({id}) {
      return post("member/card/placeRechargeOrder", {id});
    },
    // 套餐充值下单
    placePackageOrder({id}) {
      return post("member/card/placePackageOrder", {id});
    },
    // 套餐充值下单
    getMemberCardList() {
      return post("member/card/memberCardList");
    },
    // 充值记录
    getRechargeRecord() {
      return post("member/card/getRechargeRecord");
    },
    // 充值记录
    getPackageRecord() {
      return post("member/card/getPackageRecord");
    },
};
  
  export default api;
  


// WEBPACK FOOTER //
// ./src/Interface/api/chongzhi.js